import React from 'react';

import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class Dot extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            's-dot',
            className,
        ];
    }

    renderChildren() {
        return (
            <>
                <div className="s-dot__item" />
                <div className="s-dot__item" />
                <div className="s-dot__item" />
            </>
        );
    }

}

Dot.propTypes = propTypes;

Dot.defaultProps = defaultProps;

export default Dot;
